export const listMarketingFunnels = [
    {label:"Awareness",     value:0},
    {label:"Consideration", value:1},
    {label:"Purchase",      value:2},
    {label:"Loyalty",       value:3},
]